






























import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import { isIos } from "@/utils/lodash";
import { isAutoPlaySupported } from "@/utils/judgeVersion";
@Component({
  components: {}
})
export default class VideoPlayer extends Vue {
  @Prop({ default: "" })
  private poster?: any;
  @Prop({ default: "" })
  private videoSrc?: any;
  @Prop({ default: {} })
  private videoStyle?: any;
  @Prop({ default: true })
  private needLoop?: any;
  @Prop({ default: true })
  private autoplay?: any;

  private videoReady: any = false;

  get wrappeStyle() {
    return {
      backgroundImage: `url(${this.poster})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      ...this.videoStyle
    };
  }

  get isAutoPlaySupported() {
    return isAutoPlaySupported();
  }

  @Emit("ended")
  private endedEmit() {
    console.log("endedEmit ended");
  }

  private videoPlay() {
    try {
      const videoEl: any = this.$refs.videoRef;
      if (this.videoSrc && videoEl) {
        const promise = videoEl.play();
        if (promise !== undefined) {
          promise
            .catch((error: any) => {
              console.log("// Auto-play was prevented");
            })
            .then(() => {
              // console.log("Auto-play started");
            });
        }
      }
    } catch (err) {}
  }

  private clickPlayer() {
    if (!this.isAutoPlaySupported) {
      console.log("不支持自动播放");
      this.videoPlay();
    }
  }

  private replayVideo() {
    const videoEl: any = this.$refs.videoRef;
    console.log("replayVideo:", videoEl, videoEl.play);
    videoEl && videoEl.pause() && videoEl.play();
  }

  private reforceReplayVideo() {
    const videoEl: any = this.$refs.videoRef;
    videoEl.src = "";
    videoEl.src = this.videoSrc;
  }

  private mounted() {
    this.$nextTick(() => {
      const videoRef: any = this.$refs.videoRef;
      videoRef.addEventListener("canplaythrough", () => {
        console.log("canplaythrough:", videoRef.currentTime);
        this.videoReady = true;
        this.$emit("videoReady")
      });
    });
  }
}
